import React, { useContext } from 'react'
import { AppContext } from '../AppContext'

export const Marquee = () => {
    let context = useContext(AppContext)
    let envDisplay = context.settings && 
        <div className='text-center mb-5'>ENV: {context.settings.environment} | DBs: {context.settings.dataExchangeDB}, {context.settings.dirtDB}, {context.settings.capDB} | V.{context.settings.version}</div>

    return (
        <div>
            <h1 className='text-center mt-5'>PIF Manager</h1>
            {envDisplay}
        </div>
    )
}

export default Marquee
